import { render, staticRenderFns } from "./PrivacyPolicyVPC.vue?vue&type=template&id=19f34430"
import script from "./PrivacyPolicyVPC.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyVPC.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolicyVPC.vue?vue&type=style&index=0&id=19f34430&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports